import { useMemo } from 'react'
import moment from 'moment'
import { HISTORICAL_METRICS_PAST_DATA_CUTOFF_DATE } from 'domains/aggregate-store-performance/utils/constants/AggregateStorePerformanceOverviewPage.constants'

export const useDataPastCutoffDate = () =>
  useMemo(() => moment(HISTORICAL_METRICS_PAST_DATA_CUTOFF_DATE), [])
